import React from 'react';
import './Button.css';

/**
 * 统一按钮组件
 * Unified Button Component
 * 
 * @param {Object} props
 * @param {'primary'|'secondary'|'danger'|'success'|'warning'} props.variant - 按钮变体
 * @param {'sm'|'md'|'lg'} props.size - 按钮尺寸
 * @param {boolean} props.disabled - 是否禁用
 * @param {boolean} props.loading - 是否加载中
 * @param {React.ReactNode} props.children - 按钮内容
 * @param {React.ReactNode} props.icon - 图标
 * @param {'button'|'submit'|'reset'} props.type - 按钮类型
 * @param {Function} props.onClick - 点击事件
 */
const Button = ({
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  children,
  icon,
  type = 'button',
  className = '',
  onClick,
  ...props
}) => {
  const baseClass = 'btn';
  const variantClass = `btn--${variant}`;
  const sizeClass = `btn--${size}`;
  const disabledClass = disabled || loading ? 'btn--disabled' : '';
  const loadingClass = loading ? 'btn--loading' : '';
  
  const buttonClass = [
    baseClass,
    variantClass,
    sizeClass,
    disabledClass,
    loadingClass,
    className
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  return (
    <button
      type={type}
      className={buttonClass}
      disabled={disabled || loading}
      onClick={handleClick}
      {...props}
    >
      {loading && (
        <span className="btn__spinner">
          <svg className="btn__spinner-icon" viewBox="0 0 24 24">
            <circle
              className="btn__spinner-circle"
              cx="12"
              cy="12"
              r="10"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        </span>
      )}
      
      {icon && !loading && (
        <span className="btn__icon">
          {icon}
        </span>
      )}
      
      {children && (
        <span className="btn__text">
          {children}
        </span>
      )}
    </button>
  );
};

export default Button;
